import { render, staticRenderFns } from "./auth-list.vue?vue&type=template&id=d22dac12&scoped=true"
import script from "./auth-list.vue?vue&type=script&lang=ts"
export * from "./auth-list.vue?vue&type=script&lang=ts"
import style0 from "./auth-list.vue?vue&type=style&index=0&id=d22dac12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22dac12",
  null
  
)

export default component.exports